import { connect } from 'react-redux'
import { actions } from '@bt-react/store'
import { ResourcesProps } from '@bt-react/store'
import ProcessingFile from '../../ProcessingFile'

const mapStateToProps = (state) => {

    return {
        status: state.resources && state.resources.status
    }

}

const mapDispatchToProps = (dispatch: any) => ({
    setView: (view: string, state?: boolean) =>
        dispatch(actions.resource.setAttachmentView(view, state)),
    selectAttachment: (attachmentInfo: ResourcesProps) =>
        dispatch(actions.resource.selectAttachment(attachmentInfo)),
    deleteResource: (channelId: any, webcastId: any, attachmentId: any, origin?: string) =>
        dispatch(actions.resource.deleteResource(channelId, webcastId, attachmentId, origin))
})

export default connect(mapStateToProps, mapDispatchToProps)(ProcessingFile)